import { BASE_URL } from '../../config';

export function startEventsSync({
    wallet_address,
    jwt,
    onUpdate,   // (itemsArray) => void
    onError,    // (err) => void
    intervalMs = 60_000,
    apiUrl
}) {
    const endpoint = apiUrl || `${BASE_URL}/get_events`;
    if (!wallet_address || !jwt) return () => { };

    let stopped = false;

    const run = async () => {
        try {
            const res = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ address: wallet_address, jwt })
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            if (!json?.valid) throw new Error(json?.reason || 'Invalid response');
            if (!stopped && Array.isArray(json.items)) onUpdate(json.items);
        } catch (err) {
            console.warn('[events_sync] failed:', err);
            if (!stopped && onError) onError(err);
        }
    };

    run();
    const id = setInterval(run, intervalMs);
    return () => { stopped = true; clearInterval(id); };
}